import { useNavigate } from "react-router-dom";
import { PageLayout } from "../components/PageLayout.js";

export function TenantDefaultPage(props: { entitlement?: string }) {
  const nav = useNavigate();
  const canBuild = props.entitlement === "builder" || props.entitlement === "admin";
  return (
    <PageLayout title="Pages">
      <div className="card">
        <div className="muted">Nothing published yet.</div>
        {canBuild ? (
          <div className="actions" style={{ marginTop: 12 }}>
            <button className="btn btnPrimary" type="button" onClick={() => nav("/app/build/pages")}>
              Create a page
            </button>
          </div>
        ) : null}
      </div>
    </PageLayout>
  );
}
